import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from '../../../../common/constants';
import { listCapEndpointsUrl } from '../../../../config';
import api from '../../../../api';
import { RootState } from '../../../../store';
import { getCapOrgId } from '../capUtils';

export interface ICapGroup {
  id: string;
  displayName: string;
}

export interface ICapEndpoint {
  _id: string;
  orgId: string;
  endpointToken: string;
  name: string;
  groups: ICapGroup[];
  templateId: number;
  isActive: boolean;
  createdBy?: string;
  createdAt: string;
}

interface IListCapEndpointsState {
  endpoints: ICapEndpoint[];
  status: string;
  error: string | null;
}

const initialState: IListCapEndpointsState = {
  endpoints: [],
  status: Status.IDLE,
  error: null,
};

export const listCapEndpoints: any = createAsyncThunk(
  'listCapEndpoints',
  async (_, { rejectWithValue }) => {
    try {
      const orgId = getCapOrgId();
      if (!orgId) {
        return rejectWithValue({ response: { data: { message: 'Organization not found' } } });
      }
      const response = await api.get(`${listCapEndpointsUrl}?orgId=${orgId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const listCapEndpointsSlice = createSlice({
  name: 'listCapEndpoints',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listCapEndpoints.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(listCapEndpoints.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.endpoints = action.payload?.values ?? [];
      })
      .addCase(listCapEndpoints.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message ?? null;
      });
  },
});

export const selector = (state: RootState) => state.listCapEndpoints;

export default listCapEndpointsSlice.reducer;
